<template lang="pug">
  .lang-switcher
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(
        icon)
        svg.lang-switcher__icon
          use(:xlink:href="`/svg/sprite.svg?v=${Date.now()}#icon-flag-${lang}`")
      v-card(
        elevated
        slot="content")
        .lang-switcher__wrapper
          ul.lang-switcher__list
            h3.lang-switcher__title {{ 'base.lang' | translate }}
            li.lang-switcher__item(
              v-for="language in languages"
              :key="language.id"
              :class="{ 'lang-switcher__item--active': language.key === lang }"
              @click="onLangChange(language.key)")
              span.lang-switcher__item-icon
                font-awesome-icon(
                  size="sm"
                  icon="check")
              .lang-switcher__item-text {{ language.label }}
</template>

<script>
import { LANG_VAR_LOCAL_STORAGE_KEY, getDefaultLang } from '@/util/consts'
import api from '@/api'

export default {
  name: 'LangSwitcherDropdown',

  data: () => ({
    lang: getDefaultLang(),
    languages: [
      { id: 0, label: 'Українська', key: 'uk' },
      { id: 1, label: 'Русский', key: 'ru' },
      { id: 2, label: 'Polski', key: 'pl' },
      { id: 3, label: 'English', key: 'en' },
      { id: 4, label: 'Eesti', key: 'et' },
      { id: 5, label: 'Ελληνικά', key: 'el' },
      { id: 6, label: 'Español', key: 'es' },
      { id: 7, label: 'Español (US)', key: 'es-us' },
      { id: 8, label: 'Netherlands', key: 'nl' },
      { id: 9, label: 'Deutsch', key: 'de' },
      { id: 10, label: 'Français', key: 'fr' },
      { id: 11, label: 'Italiano', key: 'it' },
      { id: 12, label: 'Română', key: 'ro' },
      { id: 13, label: 'USA', key: 'us' },
    ]
  }),

  computed: {
    isAuth () {
      return this.$store.getters['account/isAuth']
    }
  },

  methods: {
    onLangChange (lang) {
      this.lang = lang
      this.$i18n.set(lang)
      localStorage.setItem(LANG_VAR_LOCAL_STORAGE_KEY, lang)

      if (this.isAuth) {
        if (lang === 'ua') {
          lang = 'uk'
        }

        const { errors } = api.account.update({profile: {language: lang}})

        if (!errors) {
          this.$toasted.show(this.$t('info.changed'))
          this.$store.dispatch('account/setLang', lang)
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.unexpected'))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .lang-switcher {

    &__wrapper {
      padding: 2rem;
      padding-right: 5rem;
      min-width: 200px;
    }

    &__icon {
      width: 2.5rem;
      height: 2.5rem;
      background-color: #F0F0F0;
      border-radius: 50%;
    }

    &__list {
      position: relative;
    }

    &__title {
      font-size: 1.5rem;
      color: $color-gray;
      margin-bottom: 1.8rem;
    }

    &__item {
      cursor: pointer;
      display: flex;
      margin-bottom: 1.3rem;
      padding-left: 3rem;
      transition: .3s ease;

      &:hover {
        color: $color-primary;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &--active {
        .lang-switcher__item-icon {
          opacity: 1;
        }
        .lang-switcher__item-text {
          color: $color-primary;
        }
      }

      &-icon {
        opacity: 0;
        position: absolute;
        left: 0;
        font-size: 1.5rem;
        color: $color-primary;
      }

      &-text {
        font-size: 1.5rem;
        line-height: 1.8rem;
      }
    }
  }
</style>
